import styled from "styled-components";

export const ModalContainer = styled.div`
  background: #0a0b0c;
  border-radius: 24px;
  border: 1px solid #18181b;
  padding: 24px;
  width: 480px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);

  max-height: 95dvh;
  overflow: auto;
  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const PromptModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PromptModalTitle = styled.h3`
  font-family: Figtree;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin: 0;
`;

export const PromptInputTitle = styled.h3`
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  letter-spacing: -1.5%;
`;
export const Badge = styled.div`
  display: flex;
  height: 14px;
  transform: rotate(14.909deg);
  padding: 2px 4px;
  align-items: center;
  justify-content: center;
  gap: 2px;

  text-transform: uppercase;

  color: #fff;
  font-family: Figtree;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: -0.21px;

  position: absolute;
  right: 2.96px;
  top: -7px;

  border-radius: 24px;
  background: ${(p) =>
    p.$pro ? "#4d9dff" : "linear-gradient(0deg, #657890 0%, #486689 100%)"};

  svg {
    height: 7.5px;
    width: auto;
    path {
      stroke: white;
    }
  }
`;
export const Button = styled.button`
  display: flex;
  padding: 6px 4px;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  flex: 1 0 0;
  border-radius: 10px;
  border: ${(p) =>
    !p.$active ? "1px solid transparent" : "1px solid var(--200, #2877d9)"};
  background: ${(p) => (p.$active ? "#18181b" : "transparent")};

  position: relative;
  transition: all 0.3s ease-in-out;
  opacity: ${(p) => (p.$disabled ? 0.5 : 1)};
  cursor: ${(p) => (p.$disabled ? "default" : "pointer")};
  outline: none;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;

  span {
    color: #fff;
    font-family: Figtree;
    opacity: 0.4;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: -0.18px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 12px;
  background: #040405;
  flex: 1 0 0;
  padding: 2px;
  align-items: center;
`;

export const PromptInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const PromptRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const PromptCloseButton = styled.button`
  background: transparent;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const RelativeContainer = styled.div`
  display: flex;
  position: relative;
`;

export const PromptTextarea = styled.textarea`
  width: 100%;
  min-height: 50px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #3d3d45;
  background: #18181b;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  color: #fff;
  letter-spacing: -0.21px;
  resize: vertical;
  outline: none;
  transition: border-color 0.2s ease;
  position: relative;

  cursor: ${(p) => (p.$disabled ? "default" : "pointer")};
  background: ${(p) => (p.$disabled ? "#040405" : "#18181b")};
  border-color: ${(p) => (p.$disabled ? "transparent" : "#3d3d45")};

  &:focus {
    border-color: #2877d9;
  }

  &::placeholder {
    color: #fff;
    opacity: 0.5;
  }
`;

export const PromptSeedInput = styled.input`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  align-self: stretch;
  border: 1px solid transparent;
  border-radius: 12px;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  transition: border-color 0.2s ease;

  background: #040405;
  padding: 6px 8px;

  &:focus {
    border-color: #2877d9;
  }

  &::placeholder {
    color: #fff;
    opacity: 0.5;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const PromptModalButtons = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
`;

export const PromptCancelButton = styled.button`
  display: flex;
  width: 100%;
  padding: 16px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;

  border-radius: 24px;
  border: 1px solid #18181b;
  background: #0a0b0c;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;

  cursor: pointer;
  border: none;
  outline: none;
`;

export const PromptSubmitButton = styled.button`
  display: flex;
  height: 44px;
  width: 100%;
  padding: 11px 32px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  border-radius: 100px;
  background: ${(p) => (p.$active ? "white" : "#18181b")};
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);

  color: ${(p) => (!p.$active ? "white" : "black")};
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;

  cursor: pointer;
  border: none;
  outline: none;

  span {
    color: black;
    font-family: Figtree;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -0.21px;

    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }
  svg {
    width: 16px;
    height: 16px;
    margin-bottom: 2px;
    path {
      fill: #000;
    }
  }
`;

export const VideoQualityContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const VideoQualityItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 6px 8px;
  align-items: center;
  border-radius: 12px;
  background: #111113;
  height: 33px;
`;

export const VideoQualityCheckboxContainer = styled.div`
  cursor: ${({ $isDisabled }) => ($isDisabled ? "not-allowed" : "pointer")};
  pointer-events: ${({ $isDisabled }) => ($isDisabled ? "none" : "auto")};
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.3 : 1)};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const VideoQualityTitle = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
`;

export const VideoQualityText = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;

export const VideoQualityDescription = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 400;
  opacity: 0.5;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-left: ${(props) => (props.$noMargin ? "0px" : "10px")};
`;

export const LockContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const ProOnly = styled.p`
  color: #4d9dff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  padding-left: 5px;
`;

// Duration
export const DurationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DurationTitle = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const DurationText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  letter-spacing: -0.21px;
`;
export const SmallRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const Duration = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: ${(p) => (p.$disabled ? "default" : "pointer")};
  gap: 10px;
  padding: 6px 8px;
  border-radius: 12px;
  background-color: #111113;
`;

export const DurationGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
`;

// FPS Slider Styles
export const FpsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FpsTitle = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const FpsSlider = styled.input`
  width: 100%;
  height: 10px;
  border-radius: 12px;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
  background: linear-gradient(
    to right,
    #366db1 0%,
    #366db1 ${({ value, min, max }) => ((value - min) / (max - min)) * 100}%,
    #18181b ${({ value, min, max }) => ((value - min) / (max - min)) * 100}%,
    #18181b 100%
  );

  border: 1px solid #3d3d45;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: #fff;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    border: none;
    transition: all 0.2s ease;
    outline: 10px solid transparent;
  }

  &::-webkit-slider-thumb:active {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(40, 119, 217, 0.5);
    outline: 3px solid rgba(255, 255, 255, 0.25);
  }

  &::-moz-range-thumb {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #fff;
    cursor: pointer;
    border: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    transition: all 0.2s ease;
  }

  &::-moz-range-thumb:active {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(40, 119, 217, 0.5);
  }

  &::-moz-range-track {
    background: transparent;
    border: none;
  }

  &::-moz-range-progress {
    background: #366db1;
  }
`;

export const FpsLabels = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

export const FpsLabel = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 13px;
  opacity: 0.5;
  font-weight: 600;
  letter-spacing: -0.195px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 121px;
  justify-content: center;

  &:first-child {
    justify-content: flex-start;
  }
  &:last-child {
    justify-content: flex-end;
  }

  @media (max-width: 768px) {
    align-items: flex-start;

    /* &:last-child {
      gap: 0px;
      align-items: flex-end;
      flex-direction: column;
    } */
  }

  @media (max-width: 455px) {
    min-width: fit-content;
    flex: 1;
  }
`;

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2.4rem;
  align-items: center;
  justify-content: center;
`;

export const EstTimeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;

export const EstTimeText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 12px;
  font-weight: ${(props) => (props.$bold ? 700 : 400)};
  letter-spacing: -0.18px;
`;
